import UserContainer from './container';

export default UserContainer;